import ConsumerGroupList from './ConsumerGroupList';

export default ConsumerGroupList;
